function Header() {
  return (
    <nav className="navbar navbar-expand-lg">
      <div className="logo-wrapper valign">
        <a href="/">
          <img src="/img/logo.png" className="logo-img" alt="" />
        </a>
      </div>

      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="icon-bar">
          <i className="ti-line-double" />
        </span>
      </button>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <a className="nav-link" href="/">
              Home
            </a>
          </li>
          <li className="nav-item dropdown">
            <a
              className="nav-link"
              href="/"
              data-toggle="dropdown"
              onClick={(e) => e.preventDefault()}
              aria-haspopup="true"
              aria-expanded="false"
            >
              {" "}
              Services <i className="ti-angle-down" />
            </a>
            <ul className="dropdown-menu last">
              <li className="dropdown-item">
                <a href="/RiskEngineering">RISK ENGINEERING</a>
              </li>
              <li className="dropdown-item">
                <a href="/Strata">STRATA</a>
              </li>
              <li className="dropdown-item">
                <a href="/CrisisManagementandBusinessContinuity">
                  CRISIS MANAGEMENT AND BUSINESS CONTINUITY
                </a>
              </li>
              <li className="dropdown-item">
                <a href="/PortfolioAnalyticsandDataInsights">
                  PORTFOLIO ANALYTICS AND DATA INSIGHTS
                </a>
              </li>
            </ul>
          </li>

          <li className="nav-item">
            <a className="nav-link" href="/Knowledge-Centre">
              Knowledge Centre
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/About-us">
              About Us
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/Contact-us">
              Contact Us
            </a>
          </li>

          <li className="nav-item butn-lightHeader">
            <a href="https://client.placedrisk.com/" target="_blank" rel="noreferrer">
              <span>Login</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Header;